import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import currentLocation from "../../Assets/CurrentWeather/currentLocation.svg";
import currentDownArrow from "../../Assets/CurrentWeather/currentDownArrow.svg";

const LocationSelector = () => {
  const { placeName } = useSelector((store) => store.dashboard);

  return (
    <Link to="/manage-location" className="group">
      <div className="flex items-center bg-slate-50 dark:bg-white/5 hover:bg-slate-100 dark:hover:bg-white/10 rounded-md gap-3 px-3 py-2 border border-slate-200 dark:border-white/10 transition-all duration-300 shadow-sm hover:shadow-md overflow-hidden min-w-0">
        <img
          src={currentLocation}
          alt="currentLocation"
          className="w-4 h-4 flex-shrink-0 group-hover:scale-110 transition-transform"
        />
        <button className="text-blackPrimaryText dark:text-darkModeBlackPrimaryText font-bold text-sm tracking-wide truncate min-w-0">
          {placeName}
        </button>
        <img
          src={currentDownArrow}
          alt="currentDownArrow"
          className="w-3 h-3 flex-shrink-0 opacity-50 dark:invert transition-transform"
        />
      </div>
    </Link>
  );
};

export default LocationSelector;
